import React, { Component } from 'react';
import './AppStatus.css';

import classnames from 'classnames';

import { connect } from 'react-redux';

class AppStatus extends Component {
  render() {
    return (
      <div className="App-Status">
        <code className="gamecode">
          <div className={classnames({ 'connection-indicator': true, 'connected': this.props.connected })}></div>
          gamecode: <span>{ this.props.gamecode || '_____' }</span><br />
          Turn: { this.props.turn || '_' } <br />
          Connected users: { this.props.numberUsers || '_' }<br />
          You are playing as: { this.props.localPlayers.join(', ') || '_' }
        </code>
      </div>
    )
  }
}
const mapStateToProps = state => {
  return {
    turn: state.turnNumber
  }
}

export default connect(mapStateToProps)(AppStatus);



// WEBPACK FOOTER //
// ./src/AppStatus.js